export default __webpack_public_path__ + "static/header-partnership-6ec4a9905aa24093879bdf79fdb5069e.jpg";